import React from "react";
import { useSelector } from "react-redux";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  return (
    <div className="footer-section section">
      <div className="container">
        <div className="row text-center">
          <div className="col-md-12">
            <ul className="footer-navigation inline-list">
              <li>
                <a className="nav-item" href="#home">
                  Accueil
                </a>
              </li>
              <li>
                <a className="nav-item" href="#challenge">
                  Challenges
                </a>
              </li>
              <li>
                <a className="nav-item" href="#program">
                  Programme
                </a>
              </li>
              <li>
                <a className="nav-item" href="#faq">
                  FAQ
                </a>
              </li>
              <li>
                <a className="nav-item" href="#contact">
                  Contact
                </a>
              </li>
            </ul>

            <ul className="social-list inline-list">
              {[
                "Facebook",
                "Linkedin",
                "Twitter",
                "Instagram",
                "Youtube",
                "GitHub",
              ].map((which, i) => {
                const key =
                  which === "Linkedin" ? "linkedIn" : which.toLowerCase();
                if (currentActivity && currentActivity.socialLinks[key]) {
                  return (
                    <li className="ml-3 ">
                      <a
                        href={currentActivity.socialLinks[key]}
                        target="_blank"
                      >
                        <i className={`fa fa-${which}`} />
                      </a>
                    </li>
                  );
                }
                return null;
              })}
            </ul>

            <ul className="footer-links inline-list">
              <li className="white">
                Copyright © 2020{" "}
                {`${
                  currentActivity &&
                  currentActivity.websiteData &&
                  currentActivity.websiteData.aboutClient &&
                  currentActivity.websiteData.aboutClient.data &&
                  currentActivity.websiteData.aboutClient.data.name
                    ? currentActivity.websiteData.aboutClient.data.name
                    : "--"
                }`}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
